import { Pipe, PipeTransform } from '@angular/core';
/*
 * Find a property value into an objects collection thanks to a property of this object
 * Usage:
 *   value | options:array,[keyLookup],[keyReturned]
 * Example:
 *   {{ 'en-GB' | options:languages,'code','description' }}
 */
@Pipe({ name: 'options' })
export class OptionsPipe implements PipeTransform {
  transform(value: any, array: any[], keyLookup: string = 'id', keyReturned: string = 'value'): any {
    let res: any[] = array.filter(item => item[keyLookup] == value);
    if (!res || !res.length) return value;

    return res[0][keyReturned];
  }
}
